import React from 'react'
import PropTypes from 'prop-types'
import { tidTrainKindClass } from '../../utils/ClassHelper'

const TRAIN_DIRECTION_CLASS = {
  'up': 'is_up',
  'down': 'is_down'
}

const NearbyMultipleTrain = ({ trains, intl }) => {
  return (
    <a className={`d-TrainPosition-train is_mystation_multiple ${TRAIN_DIRECTION_CLASS[trains[0].direction]}`}>
      <div className="d-TrainPosition-trainBody">
        <div className="d-TrainPosition-trainMark"></div>
      </div>
    </a>
  )
}

NearbyMultipleTrain.propTypes = {
  trains: PropTypes.array.isRequired,
  intl: PropTypes.object.isRequired,
}

export default NearbyMultipleTrain
